import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Card, Grid } from "@arco-design/web-react";

import { routes } from "../../../../routes/routes";

import "./NavigationCards.css";

const { GridItem } = Grid;

export function NavigationCards() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div>
      <Grid
        cols={{ xs: 2, sm: 2, md: 4 }}
        colGap={16}
        rowGap={16}
        className="admin-panel"
      >
        <GridItem>
          <Card
            hoverable
            bordered={false}
            className="admin-panel-card admin-panel-card__user-list"
            onClick={() => navigate(routes.ADMIN_USERS)}
          >
            {t('admin.dashboard.user_list')}
          </Card>
        </GridItem>
        <GridItem>
          <Card
            hoverable
            bordered={false}
            className="admin-panel-card admin-panel-card__create-user"
            onClick={() => navigate(routes.ADMIN_USER_CREATE)}
          >
            {t('admin.dashboard.create_user')}
          </Card>
        </GridItem>
        <GridItem>
          <Card
            hoverable
            bordered={false}
            className="admin-panel-card admin-panel-card__meetings"
            onClick={() => navigate(routes.ADMIN_MEETINGS)}
          >
            {t('admin.dashboard.meetings')}
          </Card>
        </GridItem>
        <GridItem>
          <Card
            hoverable
            bordered={false}
            className="admin-panel-card admin-panel-card__statistics"
            onClick={() => navigate(routes.ADMIN_STATISTICS)}
          >
            {t('admin.dashboard.statistics')}
          </Card>
        </GridItem>
      </Grid>
    </div>
  );
}
